import { useState, useRef, useEffect } from 'react';
import { MoreVertical, Trash2, Calendar as CalendarIcon, Sparkles } from 'lucide-react';
import { ConfirmationDrawer } from './ConfirmationDrawer';

export function WeekMenu({ onDeleteWeek, onViewFullWeek, onRegenerateWeek, hasAnyMeals }) {
  const [isOpen, setIsOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm hover:bg-gray-50 transition-colors"
      >
        <MoreVertical className="w-5 h-5 text-gray-700" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-12 w-56 bg-white rounded-2xl shadow-lg overflow-hidden z-10">
          <button
            onClick={() => {
              onViewFullWeek();
              setIsOpen(false);
            }}
            className="w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors border-b border-gray-100"
          >
            <CalendarIcon className="w-4 h-4 text-gray-600" />
            <span className="text-gray-700">View Full Week</span>
          </button>

          {onRegenerateWeek && hasAnyMeals && (
            <button
              onClick={() => {
                onRegenerateWeek();
                setIsOpen(false);
              }}
              className="w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors border-b border-gray-100"
            >
              <Sparkles className="w-4 h-4 text-gray-600" />
              <span className="text-gray-700">Regenerate Week</span>
            </button>
          )}

          <button
            onClick={() => {
              setShowDeleteConfirm(true);
              setIsOpen(false);
            }}
            className="w-full px-4 py-3 flex items-center gap-3 hover:bg-destructive transition-colors group"
          >
            <Trash2 className="w-4 h-4 text-destructive group-hover:text-destructive-foreground transition-colors" />
            <span className="text-destructive group-hover:text-destructive-foreground transition-colors">Clear Week</span>
          </button>
        </div>
      )}

      <ConfirmationDrawer
        isOpen={showDeleteConfirm}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={() => {
          // Close the drawer as soon as the user confirms,
          // then trigger the parent deletion handler.
          setShowDeleteConfirm(false);
          if (onDeleteWeek) {
            onDeleteWeek();
          }
        }}
        title="Clear Week"
        message="Are you sure you want to clear this week's meal plan and auto-generated shopping list items? Any items you've added yourself to the shopping list will be kept. This action cannot be undone."
      />
    </div>
  );
}

export default WeekMenu;
